// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplitPdfRouteImport } from './routes/split-pdf'
import { Route as SplitRouteImport } from './routes/split'
import { Route as PdfToPptRouteImport } from './routes/pdf-to-ppt'
import { Route as PageNumberingRouteImport } from './routes/page-numbering'
import { Route as OrganizePdfRouteImport } from './routes/organize-pdf'
import { Route as MergePdfRouteImport } from './routes/merge-pdf'
import { Route as MergeRouteImport } from './routes/merge'
import { Route as ImageToPdfRouteImport } from './routes/image-to-pdf'
import { Route as EmailToPdfRouteImport } from './routes/email-to-pdf'
import { Route as EditRouteImport } from './routes/edit'
import { Route as DeletePagesRouteImport } from './routes/delete-pages'
import { Route as AddWatermarkRouteImport } from './routes/add-watermark'
import { Route as IndexRouteImport } from './routes/index'

const SplitPdfRoute = SplitPdfRouteImport.update({
            id: '/split-pdf',path: '/split-pdf',getParentRoute: () => rootRouteImport
          })
const SplitRoute = SplitRouteImport.update({
            id: '/split',path: '/split',getParentRoute: () => rootRouteImport
          })
const PdfToPptRoute = PdfToPptRouteImport.update({
            id: '/pdf-to-ppt',path: '/pdf-to-ppt',getParentRoute: () => rootRouteImport
          })
const PageNumberingRoute = PageNumberingRouteImport.update({
            id: '/page-numbering',path: '/page-numbering',getParentRoute: () => rootRouteImport
          })
const OrganizePdfRoute = OrganizePdfRouteImport.update({
            id: '/organize-pdf',path: '/organize-pdf',getParentRoute: () => rootRouteImport
          })
const MergePdfRoute = MergePdfRouteImport.update({
            id: '/merge-pdf',path: '/merge-pdf',getParentRoute: () => rootRouteImport
          })
const MergeRoute = MergeRouteImport.update({
            id: '/merge',path: '/merge',getParentRoute: () => rootRouteImport
          })
const ImageToPdfRoute = ImageToPdfRouteImport.update({
            id: '/image-to-pdf',path: '/image-to-pdf',getParentRoute: () => rootRouteImport
          })
const EmailToPdfRoute = EmailToPdfRouteImport.update({
            id: '/email-to-pdf',path: '/email-to-pdf',getParentRoute: () => rootRouteImport
          })
const EditRoute = EditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => rootRouteImport
          })
const DeletePagesRoute = DeletePagesRouteImport.update({
            id: '/delete-pages',path: '/delete-pages',getParentRoute: () => rootRouteImport
          })
const AddWatermarkRoute = AddWatermarkRouteImport.update({
            id: '/add-watermark',path: '/add-watermark',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AddWatermarkRoute: AddWatermarkRoute,DeletePagesRoute: DeletePagesRoute,EditRoute: EditRoute,EmailToPdfRoute: EmailToPdfRoute,ImageToPdfRoute: ImageToPdfRoute,MergeRoute: MergeRoute,MergePdfRoute: MergePdfRoute,OrganizePdfRoute: OrganizePdfRoute,PageNumberingRoute: PageNumberingRoute,PdfToPptRoute: PdfToPptRoute,SplitRoute: SplitRoute,SplitPdfRoute: SplitPdfRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)